export { default } from './TableContainer';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TableContainer/index.js
// module id = 815
// module chunks = 121